import { api } from '@marketplace-web/core-api/core-api-client-util'

type ToggleBrandFollowResp = {
  is_followed: boolean
}

type ToggleBrandFollowArgs = {
  brandId: number
}

export const toggleBrandFollow = ({ brandId }: ToggleBrandFollowArgs) =>
  api.post<ToggleBrandFollowResp>('/brands/toggle_follow', {
    brand_id: brandId,
  })
